/*
 * KeyCloakService.tsx
 * Author: fwunderlich
 * Date: 19.01.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */

import React, { useEffect } from "react";
import Keycloak from "keycloak-js";
import {keycloak} from '../config/keycloak';
import settings from "../config/settings";

/* Token endpoint url
 * Change it appropriately for your purpose
 */
type Props = {
  onAuth: (token: string) => void;
  onSessionExpired: () => void
};

const initKeycloak = async (keycloak: Keycloak.KeycloakInstance) => {
  let token: string = "";
  await keycloak
    .init({ onLoad: "check-sso" })
    .then((auth) => {
      if (!auth) {
        console.log('auth required')
        keycloak.init({ onLoad: "login-required" });
      } else {
        console.info('keycloak: ',  keycloak)
        console.info('Authenticated');
        localStorage.setItem('keycloak-token', keycloak.token || '');
        localStorage.setItem('keycloak-refresh-token', keycloak.refreshToken || '');
        localStorage.setItem('keycloak-id-token', keycloak.idToken || '');
        // userLogin();
        token = keycloak.token || '';
      }
    })
    .catch(() => {
      // console.error('Authenticated Failed');
    });
  return token;
};

const updateKeycloak = async () => {
  const refreshToken = localStorage.getItem("keycloak-refresh-token") || "";

  const paramsBody =
    "client_id=" +
    keycloak.clientId +
    "&grant_type=refresh_token&refresh_token=" +
    refreshToken;

  const requestOptions = {
    method: "POST",
    useDefaultXhrHeader: false,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: paramsBody,
  };

  const response = await fetch(settings.keycloakAuthUrl, requestOptions);

  if (response.status === 200) {
    const data = await response.json();

    localStorage.setItem("keycloak-token", data.access_token);
    localStorage.setItem("keycloak-refresh-token", data.refresh_token);
  }
};

const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

const isRefreshTokenExpired = () => {
  const refreshToken = localStorage.getItem('keycloak-refresh-token') || '';
  const tokenPayload = parseJwt(refreshToken);
  const tokenExpiredTime = tokenPayload.exp;
  // console.log(tokenExpiredTime, ' (refresh-token expired time)');

  const now = new Date().getTime() / 1000 | 0;
  // console.log(now, " (now)");

  return (tokenExpiredTime - now) < 0;
};

const KeycloakService = (props: Props): JSX.Element => {
  useEffect(() => {
    (async () => {
      const token = await initKeycloak(keycloak);

      props.onAuth(token);

      if (token !== "") {
        const interval = setInterval(() => {
          // console.log('Token updated!');
          updateKeycloak().then();
          if (isRefreshTokenExpired()) {
            props.onSessionExpired();
            clearInterval(interval);
          }
        }, 200000);

        return () => clearInterval(interval);
      }
    })();
  }, []);

  return <></>;
};

export default KeycloakService;
